import {useTranslation} from "react-i18next";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function PageNotFound() {
    const {t} = useTranslation();

    return (
        <Box p={2}>
            <Paper>
                <Box p={2} display="flex" justifyContent="center" >
                    <Typography variant="h2" color="textSecondary">
                        404
                    </Typography>
                </Box>
                <Box p={2} pb={4} display="flex" justifyContent="center" >
                    <Typography variant="body2" color="textSecondary">
                        {t('pageNotFound.title')}
                    </Typography>
                </Box>
            </Paper>

        </Box>
    )
}